import { useTranslation } from 'react-i18next';
import NavBar from '../../components/NavBar';
import { RepositoryContext } from '../../store/RepositoryProvider';
import API from '../../server/api';
import { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import Table, { ALIGN_TABLE } from '../../components/Table';
import InfoDescription from '../../components/InfoDescription';
import DateFormat from '../../components/DateFormat';
import Price, { CURRENCY } from '../../components/Price';
import Badge, { BADGE_TYPE } from '../../components/Badge';
import log from '../../utils/logger';
import DayPicker, { DAY_PICKER_MODE } from '../../components/DayPicker';
import Field from '../../components/Field';
import DateTZ from '../../models/date/DateTZ';

const Salary = () => {
  const {t} = useTranslation(['common', 'salary']);

  const repository = useContext(RepositoryContext);

  const [bonuses, setBonuses] = useState([]);
  const [total, setTotal] = useState([{}]);

  const [startDate, setStartDate] = useState(new DateTZ());
  const [endDate, setEndDate] = useState(new DateTZ());

  const handleApplyRangeModal = useCallback((range) => {
    setStartDate(range.from);
    setEndDate(range.to || range.from);
  }, []);

  const loadBonuses = useCallback(async () => {
    repository.list(API.cashier.salaries, {
      fromDate: DateFormat.Request({ date: startDate }),
      toDate: DateFormat.Request({ date: endDate })
    }).then((bonuses) => {
      let _total = {
        amount: 0,
        income: 0,
        refunds: 0
      };

      bonuses.forEach((bonus) => {
        if (bonus.amount >= 0) {
          _total.income += bonus.amount;
        } else {
          _total.refunds += bonus.amount;
        }
        _total.amount += bonus.amount;
      });

      bonuses.sort((a, b) => a.date < b.date ? 1 : (a.date > b.date ? -1 : 0));

      setBonuses(bonuses);
      setTotal(_total);
    }).catch((error) => {
      log.error(error);
      setBonuses([]);
      setTotal([{}]);
    });
  }, [startDate, endDate]);

  useEffect(() => {
    loadBonuses();
  }, [startDate, endDate]);

  useEffect(() => {
    setStartDate(new Date());
    setEndDate(new Date());
  }, []);

  return (
    <div className="trip-app">
      <NavBar title={t('salary:salary.title')} />
      <div className="trip-app-body">
        <Field title={t('salary:salary.period')}>
          <DayPicker.Input mode={DAY_PICKER_MODE.RANGE} selected={{ from: startDate, to: endDate }} onChange={handleApplyRangeModal} erase/>
        </Field>
        <table className="info-table mb-0">
          <tbody>
          <tr>
            <td>
              <InfoDescription description={t('salary:total.amount')}>
                <Price currency={CURRENCY.RUB} value={total.amount} />
              </InfoDescription>
            </td>
            <td>
              <InfoDescription description={t('salary:total.income')}>
                <Price currency={CURRENCY.RUB} value={total.income} />
              </InfoDescription>
            </td>
            <td>
              <InfoDescription description={t('salary:total.refunds')}>
                <Price currency={CURRENCY.RUB} value={total.refunds} />
              </InfoDescription>
            </td>
          </tr>
          </tbody>
        </table>
        <Table cols={5}>
          {bonuses.map((salary, d) => (
            <Fragment key={d}>
              <Table.Row delim={true}  className="pb-2">
                <Table.Cell colspan={4}>
                  <InfoDescription description={
                    <>
                      {t('salary:salary.order_number')}{salary.order.number} - {salary.excursion.title}
                    </>
                  }>
                    <DateFormat.DateTime date={salary.date} tz={true} />
                  </InfoDescription>
                </Table.Cell>
                <Table.Cell align={ALIGN_TABLE.RIGHT}>
                  <Badge type={salary.amount < 0 ? BADGE_TYPE.ERROR : BADGE_TYPE.SUCCESS}><Price currency={CURRENCY.RUB} value={salary.amount}/></Badge>
                </Table.Cell>
              </Table.Row>
            </Fragment>
          ))}
        </Table>
      </div>
    </div>
  )
}

export default Salary;